import React from "react";
import ScreenLayout from "../../layout/ScreenLayout/ScreenLayout";
import { ActiveGoogleSheetsContainer } from "../../components/ActiveGoogleSheetsContainer/ActiveGoogleSheetsContainer";

const ActiveGoogleSheetsScreen = () => {
  return (
    <ScreenLayout>
      <ActiveGoogleSheetsContainer />
    </ScreenLayout>
  );
};

export default ActiveGoogleSheetsScreen;
